import { createRoot } from "react-dom/client";
import { installChunkReloadHandler } from "./chunkReloadHandler";
import App from "./App.tsx";
import "./index.css";
import "./i18n"; // Initialize i18n

// Auto-reload once if the browser tries to load stale JS chunks after a deploy
installChunkReloadHandler();

createRoot(document.getElementById("root")!).render(<App />);
